import { render, staticRenderFns } from "./YeastarSSeriesLinkToTask.vue?vue&type=template&id=6b7b7702&scoped=true"
import script from "./YeastarSSeriesLinkToTask.vue?vue&type=script&lang=js"
export * from "./YeastarSSeriesLinkToTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7b7702",
  null
  
)

export default component.exports